export class BatchIngestionPipelineMetricsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ingestionPipelineIds",
            "baseName": "ingestionPipelineIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "percentileWindow",
            "baseName": "percentileWindow",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchIngestionPipelineMetricsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
